// extracted by mini-css-extract-plugin
export default {"Container":"TyTabs_Container__1GVkD","ActiveContainerItem":"TyTabs_ActiveContainerItem__QT14h","InActiveContainerItem":"TyTabs_InActiveContainerItem__181q2"};